import { createFileRoute } from '@tanstack/react-router'
import { Bot } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SectionPage } from '../../components/SectionPage.tsx'

export const Route = createFileRoute('/_app/agents')({ component: Page })

function Page() {
  const { t } = useTranslation()
  return (
    <SectionPage
      title={t('nav.agents')}
      icon={Bot}
      emptyTitle={t('empty.agents')}
      emptyText={t('empty.agentsText')}
    />
  )
}
